<app-intro title="Page non trouvée"></app-intro>

<div class="text-center my-3 ">
  <h2 class="text-purple">Oups ! Cette page n'existe plus...</h2>
  <p class="my-3">Désolé, cette page a peut-être été supprimée ou déplacée. Pour retrouver votre chemin</p>
  <a class="btn btn-dark-purple" href="https://www.office-notarial-pace.com"> PAGE D'ACCUEIL</a>
</div>
